import { __assign, __rest } from "tslib";
import TrilogyBreadcrumb from '@trilogy-ds/react/lib/components/breadcrumb/Breadcrumb';
import React from 'react';
/**
 * Breadcrumb Component
 * @param children {React.ReactNode} Breadcrumb Children
 * @param testId {string} Test id
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS Classes
 * @param accessibilityLabel {string} Accessibility label
 */
var Breadcrumb = React.forwardRef(function (_a, ref) {
    var _b = _a.accessibilityLabel, accessibilityLabel = _b === void 0 ? 'Fil d’Ariane' : _b, others = __rest(_a, ["accessibilityLabel"]);
    return React.createElement(TrilogyBreadcrumb, __assign({ accessibilityLabel: accessibilityLabel }, others, { ref: ref }));
});
export default Breadcrumb;
//# sourceMappingURL=Breadcrumb.js.map